import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var GetSummaryTransactionListCtrl = function (fn, er, state, token, ids) {



	var config = {
		headers: {
			'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},
	};
	var data = {
		branchCode: state.trBranchCode,
		orderBy: "",
		page: state.currentPage,
		uid: state.trUid
	};

	axios
		.post(ApiConfig.url.GET_SUMMARY_TRANSACTION_LIST, data, config)
		.then(function (result) {
			fn(result.data)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});
}

export { GetSummaryTransactionListCtrl };